export class FileExplorerCountPathFilesResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "count",
            "baseName": "count",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return FileExplorerCountPathFilesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
